import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { AreaOptionType, TaxPayerType, TaxPayerTypeOptionType } from './types.ts'

interface EditProps {
  tax_payer: TaxPayerType
  tax_payer_types: TaxPayerTypeOptionType[]
  areas: AreaOptionType[]
}

export default function Edit({ tax_payer, tax_payer_types, areas }: EditProps) {
  return (
    <>
      <Head title="Editing tax payer" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing tax payer</h1>

        <Form
          tax_payer={tax_payer}
          tax_payer_types={tax_payer_types}
          areas={areas}
          action={`/tax_payers/${tax_payer.id}`}
          method="patch"
          submitText="Mettre à jour le contribuable"
        />

        <Link
          href={`/tax_payers/${tax_payer.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Voir ce contribuable
        </Link>
        <Link
          href="/tax_payers"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux contribuables
        </Link>
      </div>
    </>
  )
}
